(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["axia-product-card-colors"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.axia-card-color-swatch');
    if (!swatch) return;

    const cardClass = swatch.dataset.cardClass;
    const card = swatch.closest(`.${cardClass}`);
    if (!card) return;

    const image = card.querySelector('img');
    if (image && swatch.dataset.imageSrc) {
      image.src = swatch.dataset.imageSrc;
      if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
    }

    if (swatch.dataset.productUrl) {
      card.querySelectorAll('a').forEach((link) => {
        link.href = swatch.dataset.productUrl;
      });
    }

    card.querySelectorAll('.axia-card-color-swatch').forEach((button) => {
      button.classList.toggle('is-selected', button === swatch);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
